module.exports = __webpack_public_path__ + "static/media/nextGen-01.70a72ac6.png";